import React from "react";
import { Form, Input, Select, InputNumber, Checkbox } from "antd";
interface props {
  errors?: any;
  form?: any;
  emailExists?: boolean;
  setEmailExists?: any;
  previousInfo?: any;
}

const PersonalInformation: React.FC<props> = (props) => {
  const { previousInfo } = props;
  console.log("previousInfo", previousInfo);
  const { Option } = Select;

  return (
    <div className="answer-input-wrapper personal-information-wrapper">
      <Form.Item
        name="first_name"
        rules={[{ required: true, message: "Your first name is required" }]}
      >
        <Input placeholder="First Name"></Input>
      </Form.Item>
      <Form.Item
        name="last_name"
        rules={[{ required: true, message: "Your last name is required" }]}
      >
        <Input placeholder="Last Name"></Input>
      </Form.Item>
      <Form.Item
        name="pronoun"
        rules={[{ required: true, message: "Your pronoun is required" }]}
      >
        <Select
          className="personal-information-wrapper__select"
          style={{ width: 200 }}
          placeholder="Pronoun"
        >
          <Option value="She/Her">She/Her</Option>
          <Option value="He/Him">He/Him</Option>
          <Option value="They/Them">They/Them</Option>
          <Option value="Prefer not to say">Prefer not to say</Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="age"
        rules={[
          {
            required: true,
            message: "Your age is required",
          },
          {
            validator: (_, value) =>
              value === undefined || value === null
                ? Promise.resolve()
                : value >= 15
                ? Promise.resolve()
                : Promise.reject(
                    new Error("Oops! You need to be 15 or older to continue.")
                  ),
          },
        ]}
      >
        <InputNumber placeholder="Age" />
      </Form.Item>
      <Form.Item
        name="email"
        rules={[
          { required: true, message: "Your email is required" },
          { type: "email", message: "Entered email is not valid" },
        ]}
      >
        <Input
          placeholder="Email"
          type="email"
          disabled={previousInfo?.email ? true : false}
        />
      </Form.Item>
      <Form.Item name="contact">
        <InputNumber placeholder="Phone" />
      </Form.Item>
      <Form.Item name="user_hear_about">
        <Input placeholder="How did you hear about us?"></Input>
      </Form.Item>
      <Form.Item name="client_occurrence">
        <Select
          className="personal-information-wrapper__select"
          style={{ width: 200 }}
          placeholder="Are you a new or returning client?"
        >
          <Option value="New">New</Option>
          <Option value="Returning">Returning</Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="terms-condition"
        className="terms-condition-checkbox"
        valuePropName="checked"
        rules={[
          {
            validator: (_: any, value: any) =>
              value
                ? Promise.resolve()
                : Promise.reject(
                    "You must agree to the privacy policy and terms & services to continue."
                  ),
          },
        ]}
      >
        <Checkbox className="ant-input">
          <span className="checkbox-label">I agree to</span>{" "}
          <a
            href="https://missingskincare.com/privacy-policy/"
            target="_blank"
            className="privacy-policy"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{" "}
          <span style={{ cursor: "text" }}>and</span>{" "}
          <a
            href="https://missingskincare.com/terms-of-use/"
            target="_blank"
            className="privacy-policy"
            rel="noreferrer"
          >
            Terms & Services
          </a>
        </Checkbox>
      </Form.Item>
    </div>
  );
};

export default PersonalInformation;
